var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphicRighttop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 196,
    viewBox: "0 0 210 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 91.8286C0 134.214 58.8447 196 101.292 196C143.739 196 117.964 158.091 117.964 115.705C117.964 95.9065 153.513 57.8253 149.716 40.2907C144.794 17.5582 119.468 0 96.8489 0C54.4019 0 0 49.4432 0 91.8286Z",
    fill: "#D6EFF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161 161C161 175.912 179.088 187 194 187C208.912 187 210 172.412 210 157.5C210 142.588 204.912 131 190 131C175.088 131 161 146.088 161 161Z",
    fill: "#D6EFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicRighttop);
export default __webpack_public_path__ + "static/media/Graphic-righttop.0f21da7e07394fc53bdcf2461ef7f7d2.svg";
export { ForwardRef as ReactComponent };